import type { MissionListItem } from '../hooks/useMissionsListView'

export const selectFeaturedMission = (
  items: MissionListItem[]
): MissionListItem | null => items.find(item => item.featured) ?? null
